<template>
  <div class="bonusesComp">
    <bonuses-filters-comp v-show="showFilters" :showSliders="showFilters"/>
    <tbl-comp
      v-show="!showFilters"
      :model="this.$store.getters[`${this.moduleName}/getModel`]"
      :hasExport="true"
      :paging="true"
      :moduleName="moduleName"
      :searchInput="true"
      :searchPlaceholder="'Номер телефона'"
      :searchMask="$helpers.input.masks.phone"
      :filters="onFilter"
      :params="onFilter ? Object.assign(filters, params) : Object.assign(params)"
    />

  </div>
</template>

<script>

export default {
  name: 'bonusesComp',
  props: {
    params: { type: Object, default: () => {} },
    onFilter: { type: Boolean, default: () => false }
  },
  data: function () {
    return {
      show: false,
      moduleName: 'bonuses'
    }
  },
  created: function () {
    this.$store.dispatch(`${this.moduleName}/getFilters`, {})
  },
  computed: {
    showFilters: function () {
      return this.$store.getters[`${this.moduleName}/getShowFilters`]
    },
    filters: function () {
      return this.$store.getters[`${this.moduleName}/getFiltersQuery`]
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">

.label_info {
  float: right;
  margin: 5px 32px 5px auto;
}

</style>
